import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-th",
  "use": "icon-icon-th-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-th\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#f4f5f8\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#2d2a4a\" d=\"M0 173.4h512V344H0z\" />\n    <path fill=\"#a51931\" d=\"M0 0h512v88H0zm0 426.7h512V512H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol